module.exports = __webpack_public_path__ + "img/1581649997.f0a221be.jpg";